module.exports = __webpack_public_path__ + "static/media/captcha_icon.1dc9569a.svg";